<!--
 * @Description: 注册数变化趋势无数据组件
 * @Author:sunhuihong
 * @Date: 2022-07-19 08:33:29
 * @LastEditTime: 2022-07-19 17:33:29
-->
<template>
  <div class="register-trend-charts" >
    <div class="register-trend-charts-header">
      <span style="font-weight: 600; color: #333333;">注册数变化趋势</span>
      <div class="tabs">
        <span @click="changeTabs(item)" v-for="item in registerTrendHeaderData" :key="item.id" 
          :class="registerTabsIndex == item.id ? 'active-tabs' : 'defaut-active'">
          {{item.name}}
        </span>
      </div>
    </div>
    <el-empty class="empty-img" description="暂无数据"></el-empty>
  </div>
</template>

<script>
export default {
  name: 'RegisterTrendEmptyData',
  props: ['id', "registerTabsIndex", "registerTrendHeaderData"],
  data() {
    return {
    }
  },

  methods: {
    changeTabs(item) {
      if (this.registerTrendHeaderData.length == 1) return;
      this.$emit("handle-register-tabs", item)
    },
  },
}
</script>

<style  scoped>
.register-trend-charts {
  height: 344px;
  border-radius: 6px;
  border: 1px solid #D7DDE5;
}

.register-trend-charts-header {
  display: flex;
  justify-content: space-between;
  height: 46px;
  line-height: 46px;
  padding: 0 20px;
  border-bottom: 1px solid #D7DDE5;
}

.tabs :nth-child(1) {
  margin-right: 30px;
}

.active-tabs {
  font-size: 16px;
  color: #3E7EF5;
  display: inline-block;
  height: 38px;
  border-bottom: 3px solid #3E7EF5;
  cursor: pointer;
}

.defaut-active {
  font-size: 16px;
  color: #666666;
  display: inline-block;
  height: 44px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/overview/components/RegisterTrendEmptyData.vue